import '../FileAnalysis.scss';

function Form48({ text }: { text?: string }) {
  return <div className="FileAnalysis__results--form48-container" dangerouslySetInnerHTML={{ __html: text || '' }} />;
}

export default Form48;
